import Vue from 'vue';
import { AI_CHAT_CONVERSATION_STORAGE_KEY, AI_CHAT_MESSAGES_STORAGE_KEY } from './constants';
import {
  ADD_USER_MESSAGE,
  START_ASSISTANT_MESSAGE,
  UPDATE_STREAMING_ASSISTANT,
  RECONCILE_ASSISTANT,
  SET_CONVERSATION_ID,
  SET_SENDING,
  SET_ERROR,
  RESET,
  FREEZE_ASSISTANT_STREAM,
  RESTORE_MESSAGES,
  SET_AI_ACCESS,
} from './types';

function persistMessages(messages) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    if (messages && messages.length > 0) {
      sessionStorage.setItem(AI_CHAT_MESSAGES_STORAGE_KEY, JSON.stringify(messages));
    } else {
      sessionStorage.removeItem(AI_CHAT_MESSAGES_STORAGE_KEY);
    }
  } catch {
    /* quota or private mode — non-fatal */
  }
}

function persistConversationId(id) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    if (id) {
      sessionStorage.setItem(AI_CHAT_CONVERSATION_STORAGE_KEY, id);
    } else {
      sessionStorage.removeItem(AI_CHAT_CONVERSATION_STORAGE_KEY);
    }
  } catch {
    /* quota or private mode — non-fatal */
  }
}

export default {
  [ADD_USER_MESSAGE](state, { id, text }) {
    state.messages.push({ id, role: 'user', text });
    persistMessages(state.messages);
  },
  [START_ASSISTANT_MESSAGE](state, { id }) {
    state.messages.push({ id, role: 'assistant', text: '' });
    state.activeStreamAssistantId = id;
    state.frozenAssistantStreamId = null;
  },
  [UPDATE_STREAMING_ASSISTANT](state, { id, text }) {
    if (state.frozenAssistantStreamId === id) return;
    if (state.activeStreamAssistantId !== id) return;
    const idx = state.messages.findIndex((m) => m.id === id);
    if (idx !== -1) Vue.set(state.messages, idx, { ...state.messages[idx], text });
  },
  [RECONCILE_ASSISTANT](state, { id, text }) {
    const idx = state.messages.findIndex((m) => m.id === id);
    if (idx !== -1) Vue.set(state.messages, idx, { ...state.messages[idx], text });
  },
  [FREEZE_ASSISTANT_STREAM](state, id) {
    state.frozenAssistantStreamId = id;
    persistMessages(state.messages);
  },
  [SET_CONVERSATION_ID](state, id) {
    if (id == null || id === '') {
      state.conversationId = null;
      persistConversationId(null);
      return;
    }
    const normalized = String(id).trim();
    if (!normalized) {
      state.conversationId = null;
      persistConversationId(null);
      return;
    }
    state.conversationId = normalized;
    persistConversationId(normalized);
  },
  [SET_SENDING](state, value) {
    state.isSending = value;
  },
  [SET_ERROR](state, err) {
    state.error = err;
  },
  [RESET](state) {
    state.messages = [];
    state.conversationId = null;
    state.activeStreamAssistantId = null;
    state.frozenAssistantStreamId = null;
    state.isSending = false;
    state.error = null;
    persistConversationId(null);
    persistMessages([]);
  },
  [RESTORE_MESSAGES](state, messages) {
    if (Array.isArray(messages) && messages.length > 0) {
      state.messages = messages;
    }
  },
  [SET_AI_ACCESS](state, value) {
    state.aiAccess = value;
  },
};
